// Explicit lib path; the aggregated entry resolves to the global window.Notification.
import Notification from 'element-ui/lib/notification';

export default Notification;
